export const columns = [
  {
    name: 'Enzyme',
    selector: (row) => row.enzyme,
    width: '80px'
  },
  {
    name: 'Function',
    selector: (row) => row.function,
    width: '270px'
  },
  {
    name: 'Organism',
    selector: (row) => row.organism,
    width: '220px',
    id: 'results-organism'
  },
  {
    name: 'Parts',
    selector: (row) => row.parts,
    width: '150px',
    id: 'results-parts'
  },
  {
    name: 'UniProt entry',
    selector: (row) => row.uniProt
  }
]

export const data = [
  {
    enzyme: 'P0DTR4',
    function: <span>N-acetyl-&alpha;-D-galactosamine deacetylase</span>,
    organism: <i>Flavonifractor plautii</i>,
    parts: <a href="http://parts.igem.org/Part:BBa_K4726000">BBa_K4726000</a>,
    uniProt: 'P0DTR4'
  },
  {
    enzyme: 'P0DTR5',
    function: <span>&alpha;-D-galactosamine galactosaminidase</span>,
    organism: <i>Flavonifractor plautii</i>,
    parts: <a href="http://parts.igem.org/Part:BBa_K4726001">BBa_K4726001</a>,
    uniProt: 'P0DTR5'
  },
  {
    enzyme: 'GH110b',
    function: <span>&alpha;-galactosidase 110b</span>,
    organism: <i>Bacteroides fragilis</i>,
    parts: <a href="http://parts.igem.org/Part:BBa_K4726002">BBa_K4726002</a>,
    uniProt: 'Q5LGZ8'
  },
  {
    enzyme: 'NAGA',
    function: <span>&alpha;-N-Acetylgalactosaminidase 109A</span>,
    organism: <i>Elizabethkingia meningoseptica</i>,
    parts: <a href="http://parts.igem.org/Part:BBa_K3717016">BBa_K3717016</a>,
    uniProt: 'A4Q8F7'
  },
  {
    enzyme: 'GH110a',
    function: <span>&alpha;-galactosidase 110a</span>,
    organism: <i>Bacteroides fragilis</i>,
    parts: <a href="http://parts.igem.org/Part:BBa_K3717006">BBa_K3717006</a>,
    uniProt: 'Q5L7M8'
  }
]
